
import React from "react";
import { Search, Download, Star } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import FadeInWhenVisible from "./FadeInWhenVisible";

const HowItWorksSection: React.FC = () => {
  return (
    <section className="py-20 bg-white dark:bg-gray-950">
      <div className="container mx-auto px-4">
        <FadeInWhenVisible>
          <div className="text-center mb-16">
            <Badge className="mb-2">Simple Process</Badge>
            <h2 className="text-3xl md:text-4xl font-bold mb-4 dark:text-white">How It Works</h2>
            <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
              Get started with AI agents in just a few simple steps
            </p>
          </div>
        </FadeInWhenVisible>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
          <div className="hidden md:block absolute top-1/2 left-0 right-0 h-0.5 bg-gray-200 dark:bg-gray-800 -translate-y-1/2 z-0" />

          <FadeInWhenVisible delay={0.1}>
            <div className="relative z-10 flex flex-col items-center text-center">
              <div className="w-20 h-20 rounded-full bg-purple-100 dark:bg-purple-900/30 flex items-center justify-center mb-6 relative">
                <span className="absolute inset-0 rounded-full bg-purple-600 dark:bg-purple-500 opacity-10 animate-ping" />
                <Search className="h-8 w-8 text-purple-600 dark:text-purple-400" />
                <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-purple-600 text-white flex items-center justify-center font-bold">
                  1
                </div>
              </div>
              <h3 className="text-xl font-bold mb-3 dark:text-white">Discover</h3>
              <p className="text-gray-600 dark:text-gray-300">
                Browse through thousands of AI agents created by developers and companies worldwide
              </p>
            </div>
          </FadeInWhenVisible>

          <FadeInWhenVisible delay={0.2}>
            <div className="relative z-10 flex flex-col items-center text-center">
              <div className="w-20 h-20 rounded-full bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center mb-6">
                <Download className="h-8 w-8 text-blue-600 dark:text-blue-400" />
                <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-blue-600 text-white flex items-center justify-center font-bold">
                  2
                </div>
              </div>
              <h3 className="text-xl font-bold mb-3 dark:text-white">Download</h3>
              <p className="text-gray-600 dark:text-gray-300">
                Download agents that match your needs, with clear documentation and usage instructions
              </p>
            </div>
          </FadeInWhenVisible>

          <FadeInWhenVisible delay={0.3}>
            <div className="relative z-10 flex flex-col items-center text-center">
              <div className="w-20 h-20 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center mb-6">
                <Star className="h-8 w-8 text-green-600 dark:text-green-400" />
                <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-green-600 text-white flex items-center justify-center font-bold">
                  3
                </div>
              </div>
              <h3 className="text-xl font-bold mb-3 dark:text-white">Share</h3>
              <p className="text-gray-600 dark:text-gray-300">
                Create and upload your own AI agents to share with the community and get feedback
              </p>
            </div>
          </FadeInWhenVisible>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
